import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import createMarkup from 'helpers/createMarkup';
import img1 from '../../../../assets/img/faq/img1.png';
import img2 from '../../../../assets/img/faq/img2.png';
import img3 from '../../../../assets/img/faq/img3.png';
import img4 from '../../../../assets/img/faq/img4.png';
import img5 from '../../../../assets/img/faq/img5.png';
import img6 from '../../../../assets/img/faq/img6.png';
import img7 from '../../../../assets/img/faq/img7.png';
import img8 from '../../../../assets/img/faq/img8.png';
import img9 from '../../../../assets/img/faq/img9.png';
import img10 from '../../../../assets/img/faq/img10.png';
import img11 from '../../../../assets/img/faq/img11.png';
import img12 from '../../../../assets/img/faq/img12.png';
import img13 from '../../../../assets/img/faq/img13.png';
import img14 from '../../../../assets/img/faq/img14.png';
import img15 from '../../../../assets/img/faq/img15.png';
import img16 from '../../../../assets/img/faq/img16.png';
import img17 from '../../../../assets/img/faq/img17.png';
import img19 from '../../../../assets/img/faq/img19.png';
import img20 from '../../../../assets/img/faq/img20.png';
import img22 from '../../../../assets/img/faq/img22.png';
import img23 from '../../../../assets/img/faq/img23.png';
import img24 from '../../../../assets/img/faq/img24.png';
import img25 from '../../../../assets/img/faq/img25.png';
import img26 from '../../../../assets/img/faq/img26.png';

const imgs = [
      img1,img1,img2,img3,img4,img5,img6,img7,
      img8,img9,img10,img11,img12,img13,img14,
      img15,img16,img17,img19,img20,img22,img24,
      img25,img26,img24,img25,img26
    ]

const FaqAccordionItem = ({ faq, isFirst, isLast }) => {
  return (
    <Card
      className={classNames('shadow-none', {
        'rounded-bottom-0': isFirst,
        'border-bottom': !isLast,
        'rounded-0': !isLast && !isFirst
      })}
    >
      <Accordion.Item eventKey={faq.id} className="border-0">
        <Card.Header className="p-0" id={`faqAccordionHeading${faq.id}`}>
          <Accordion.Button className="btn btn-link text-decoration-none d-block w-100 py-2 px-3 border-0 rounded-0 text-start shadow-none">
            <div className="d-flex">
              <FontAwesomeIcon
                icon="caret-right"
                className="accordion-icon me-3 mt-1"
                transform="shrink-2"
              />
              <span className="fw-medium font-sans-serif text-900">
                {faq.title}
              </span>
            </div>
          </Accordion.Button>
        </Card.Header>
        <Accordion.Body className="p-0">
          <Card.Body className="pt-2">
            <div
              className="ps-3"
              dangerouslySetInnerHTML={createMarkup(faq.description)}
            />
            <img
              src={imgs[faq.id]}
              id={faq.id}
              alt="FAQ illustration"
              className="img-fluid mx-auto d-block faq-img"
            />
            {faq.title == 'Reportes' && <img
              src={img23}
              id={faq.id}
              alt="FAQ illustration"
              className="img-fluid mx-auto d-block faq-img"
            /> }
          </Card.Body>
        </Accordion.Body>
      </Accordion.Item>
    </Card>
  );
};

FaqAccordionItem.propTypes = {
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  faq: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
};

export default FaqAccordionItem;
